import { Component, Input, OnInit } from '@angular/core';
import { Labels } from 'src/app/app.models';

@Component({
    selector: 'app-status-updates',
    templateUrl: './status-updates.component.html',
    styleUrls: ['./status-updates.component.scss'],
    standalone: false
})
export class StatusUpdatesComponent {
  @Input() flow!: string | undefined;
  @Input() wallet: any = '';
  @Input() calledFrom: any = '';
  @Input() isformFreeLocation: boolean = false;
  items!: any;

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.getStepsContent();
  }
  public get labels() {
    return this._labels;
  }

  private _transactionStatus: string = '';
  @Input() public set transactionStatus(status: string) {
    this._transactionStatus = status.toLowerCase();
  }
  public get transactionStatus() {
    return this._transactionStatus;
  }

  public isMobile: boolean;

  constructor() {}

  getStepsContent() {
    let firstBulletPoint = '';

    if (
      this.wallet?.toLowerCase() === 'vibrant' ||
      this.wallet?.toLowerCase() === 'wyre' ||
      this.wallet?.toLowerCase() === 'meru' ||
      this.wallet?.toLowerCase() === 'cinko'
    ) {
      firstBulletPoint =
        this.labels.stellar.statusUpdates.withdraw.firstBulletVibrant;
    } else {
      firstBulletPoint =
        this.labels.stellar.statusUpdates.withdraw.firstBulletLobstr;
    }

    if (
      this.flow === 'withdraw' &&
      this.transactionStatus === 'pending_user_transfer_complete'
    ) {
      this.items = [
        {
          orderId: 1,
          description: this.labels.stellar.statusUpdates.withdraw.secondBullet,
        },
      ];
    } else if (this.flow === 'withdraw') {
      this.items = [
        {
          orderId: 1,
          description: firstBulletPoint,
        },
        {
          orderId: 2,
          description: this.labels.stellar.statusUpdates.withdraw.secondBullet,
        },
      ];
    } else if (this.flow === 'deposit' && !this.isformFreeLocation) {
      const depositNonFromfreeLabels =
        this.labels.stellar.statusUpdates.depositNonFromFreeLabels;
      this.items = [
        {
          orderId: 1,
          description: depositNonFromfreeLabels.firstPoint,
        },
        {
          orderId: 2,
          description: depositNonFromfreeLabels.secondPoint,
          subItems: [
            {
              orderId: 1,
              description: depositNonFromfreeLabels.firstBulletInSecondPoint,
            },
            {
              orderId: 2,
              description: depositNonFromfreeLabels.secondBulletInSecondPoint,
            },
            {
              orderId: 3,
              description: depositNonFromfreeLabels.thirdBulletInSecondPoint,
            },
          ],
        },
        {
          orderId: 3,
          description: depositNonFromfreeLabels.thirdPoint,
          subItems: [
            {
              orderId: 1,
              description: depositNonFromfreeLabels.firstBulletInThirdPoint,
            },
            {
              orderId: 2,
              description: depositNonFromfreeLabels.secondBulletInThirdPoint,
            },
          ],
        },
        {
          orderId: 4,
          description: depositNonFromfreeLabels.fourthPoint,
        },
      ];
    } else if (this.flow === 'deposit') {
      this.items = [
        {
          orderId: 1,
          description: this.labels.stellar.statusUpdates.deposit.firstBullet,
        },
        {
          orderId: 2,
          description: this.labels.stellar.statusUpdates.deposit.secondBullet,
        },
        {
          orderId: 3,
          description: this.labels.stellar.statusUpdates.deposit.thirdBullet,
        },
      ];
    }
  }
}
